import styled from 'styled-components'

export default (styled.div || styled.View)`
  padding: 25px;
  position: relative;
`
